module.exports = __webpack_public_path__ + "img/icon98.19233ecd.png";